import { useRouter } from 'next/router'
import { Hero as Component } from 'ui-components'
import { useAuthContext, useFederatedAuth } from 'user-auth'
import { getRedirectCreateMapLink } from 'utils'

function Hero() {
  const router = useRouter()
  const { loading, initialized, authenticated } = useAuthContext()
  const { gotoSignInPage } = useFederatedAuth()

  const ready = initialized && !loading

  const handleClick = () => {
    if (!authenticated) {
      gotoSignInPage({ postSignIn: getRedirectCreateMapLink() })
      return
    }

    router.push(getRedirectCreateMapLink())
  }

  return (
    <Component
      slotProps={{
        Button: { disabled: !ready, onClick: handleClick }
      }}
    />
  )
}

export { Hero }
